import type { ReviewTimesheet } from "../api/types";
import { localMidnight, parseDateKey } from "./date";

export const LOCK_ACTION = "Valider et verrouiller";

/** Ce que vaut le verrouillage, dit là où on le déclenche. */
export const LOCK_NOTE =
  "Valider et verrouiller fige la feuille et l'envoie dans l'export paie";

// Au-delà, la feuille est signalée en retard : la paie l'attend.
export const REVIEW_OVERDUE_DAYS = 7;

/** Jours écoulés depuis la fin de la période, en dates locales. */
export function daysSinceEnd(ts: ReviewTimesheet, today: Date): number {
  const end = parseDateKey(ts.period_end.slice(0, 10));
  return Math.round(
    (localMidnight(today).getTime() - end.getTime()) / 86_400_000,
  );
}

export function isOverdue(ts: ReviewTimesheet, today: Date): boolean {
  return daysSinceEnd(ts, today) > REVIEW_OVERDUE_DAYS;
}

/** File de revue, la plus ancienne période en tête : c'est celle que la paie
 * attend depuis le plus longtemps. */
export function sortReviewQueue(list: ReviewTimesheet[]): ReviewTimesheet[] {
  return [...list].sort((a, b) => a.period_start.localeCompare(b.period_start));
}
